import { render, staticRenderFns } from "./password-index.vue?vue&type=template&id=79a1d69e"
import script from "./password-index.vue?vue&type=script&lang=js"
export * from "./password-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports